import {Component, OnInit} from '@angular/core';
import {ViewService} from '../../../services/view/view.service';
import {AuthService} from "../../../services/auth/auth.service";
import {RouteService} from "../../../services/route/route.service";

@Component({
  selector: 'app-oauth',
  templateUrl: './oauth.component.html'
})
export class OauthComponent implements OnInit {
  constructor(
    public viewService: ViewService,
    private authService: AuthService,
    private routeService: RouteService
  ) {
    this.routeService.queryParams.subscribe((params) => {
      if (params?.state) {
        this.state = params.state;
      }
    });
  }

  public isLoading: boolean = true;
  public response: any;
  public state: string;

  ngOnInit(): void {
    if (this.state) {
      this.run();
    } else {
      this.isLoading = false;
      this.response = null;
    }
  }

  public run(): void {
    this.isLoading = true;
    this.authService.oauthLogin(this.state).subscribe({
      next: (res) => {
        if (res?.redirect_uri) {
          window.location.href = res.redirect_uri;
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.response = err;
      }
    });
  }

  public cancel(): void {
    this.routeService.navigate('/');
  }
}
